import Spinner from './Spinner';

function LoadingScreen() {
  return (
    <div className="h-screen flex justify-center items-center">
      <Spinner />
    </div>
  );
}

export default LoadingScreen;